module.exports = __webpack_public_path__ + "static/media/galeria-fotos-6-big.23fd7005.png";